var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:( _obj = {}, _obj[this.getButtonClass] = true, _obj[this.activeClass] = this.isActive, _obj['num-button'] =  _vm.buttonType === 'switchNumberKeyboard', _obj ),style:({
    width: (_vm.buttonWidth + "px !important"),
    backgroundColor: _vm.backgroundColorStyle,
  }),on:{"click":_vm.onClick}},[(!_vm.isDefault || !_vm.isSpecial || _vm.isSpace)?_c('div',[_vm._v(" "+_vm._s(_vm.displayText)+" ")]):_c('i',{class:_vm.iconClass})])}
var staticRenderFns = []

export { render, staticRenderFns }